import { pipe } from 'fp-ts/lib/function';
import { failure, number, parse, string, success, union } from 'io-ts/Decoder';

export const PageNumber = pipe(
	union(string, number),
	parse((s) => {
		const n = Number(s);
		return !isNaN(n) ? success(n) : failure(s, 'must be a number');
	}),
	parse((s) => {
		const parsed = parseInt(`${s}`, 10);

		if (isNaN(parsed)) {
			return failure(parsed, 'NaN');
		}

		if (parsed !== s) {
			return failure(parsed, 'integer');
		}

		if (parsed < 0) {
			return failure(parsed, 'positive');
		}

		return success(parsed);
	})
);
